import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}function n(e,t,n,r){let i=[...e];return i.splice(t,n,...r),i}export{t as splice};
//# sourceMappingURL=splice-DeCwsTpm.js.map